<script lang="ts" setup>
// Properties
import { onMounted } from "vue";
import H2Heading from "~/components/H2Heading.vue";
import { useHelper } from "~/composables/helper";

// Data
const slides = ref();
slides.value = await useHelper().getCollection("abc_cares", "", 20, 1, "-date");

// Functions

onMounted(async () => {
    // swiper element
    const swiperEl = document.querySelector("#abc-cares-slides");
    const btnNext = document.querySelector("#abc-cares-slides-btn-next");
    const btnPrev = document.querySelector("#abc-cares-slides-btn-prev");

    // swiper parameters
    const swiperParams = {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        navigation: {
            nextEl: btnNext,
            prevEl: btnPrev,
        },
        autoplay: {
            delay: 8000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
        },
        on: {
            init() {
                // ...
            },
        },
    };

    // now we need to assign all parameters to Swiper element
    Object.assign(swiperEl, swiperParams);

    // and now initialize it
    swiperEl?.initialize();
});
</script>

<template>
    <div class="py-20">
        <H2Heading size="text-2xl md:text-3xl" class="mb-2 text-center">ABC Cares</H2Heading>
        <p class="mb-6 text-center md:px-20 lg:px-48">
            ABC cares about our communities and the schools we serve. We know that curriculum is only one part of
            student success and that strong communities and make all the difference. In our home state of Georgia and
            the other states we serve, we believe in being part of those strong communities.
        </p>
        <p class="mb-10 text-center md:px-20 lg:px-48">
            From backpack drives to charity tournaments to helping students and teachers get back on their feet after
            natural disasters, we will be here to help.
        </p>

        <!-- Slides -->
        <div class="relative">
            <swiper-container
                id="abc-cares-slides"
                init="false"
                class="swiper-container swiper-initialized swiper-horizontal px-2 md:w-[70%] lg:w-[80%] xl:w-[87%]"
            >
                <swiper-slide v-for="(slide, index) in slides" :key="index" class="overflow-hidden">
                    <div
                        class="items-center overflow-hidden rounded-xl border pb-6 drop-shadow-sm lg:mx-4 lg:flex lg:py-0 xl:mx-8"
                    >
                        <div class="relative w-full flex-1 overflow-hidden lg:w-2/5">
                            <img
                                :src="slide.photo[0].url"
                                :alt="slide.title"
                                class="mx-auto hidden h-64 md:block lg:inline-block xl:h-72"
                            />
                            <img
                                src="/images/about/About-us-carousel-bubbles_68x342px.svg"
                                class="hidden h-72 xl:inline-block"
                            />
                            <img
                                src="/images/about/About-us-carousel-bubbles_mobile_306x54px.svg"
                                class="top-0 right-0 -z-10 float-right -mt-4 max-h-32 md:absolute lg:hidden"
                            />
                        </div>
                        <div class="mt-2 flex-1 pr-4 pl-4 text-center lg:mt-0 lg:pr-8 lg:text-left xl:pr-16">
                            <div class="font-semibold">{{ slide.title }}</div>
                            <p class="mt-3 leading-tight" v-html="slide.content"></p>
                        </div>
                    </div>
                </swiper-slide>
            </swiper-container>

            <div
                class="absolute top-0 right-0 z-10 hidden h-full items-center justify-center border-l-0 bg-white p-4 shadow-xl shadow-white md:flex"
            >
                <div
                    id="abc-cares-slides-btn-next"
                    class="flex-none cursor-pointer rounded-full border px-5 py-3 shadow-lg hover:border-2"
                >
                    <img src="/images/fa/chevron-right-regular.svg" class="w-5" />
                </div>
            </div>
            <div
                class="absolute top-0 left-0 z-10 hidden h-full items-center justify-center border-r-0 bg-white p-4 shadow-xl shadow-white md:flex"
            >
                <div
                    id="abc-cares-slides-btn-prev"
                    class="flex-none cursor-pointer rounded-full border px-5 py-3 shadow-lg hover:border-2"
                >
                    <img src="/images/fa/chevron-left-regular.svg" class="w-5" />
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
